export default __webpack_public_path__ + "static/media/custom_receptor.b4f18e02.svg";